/* @flow */

import type { $WidgetSettings } from '../types';
import { Environments } from 'CoreConstants';

const SET_WIDGET_SETTINGS = 'dsw/settings/SET_WIDGET_SETTINGS';
const UNSET_WIDGET_SETTINGS = 'dsw/settings/UNSET_WIDGET_SETTINGS';
const MODIFY_WIDGET_SETTINGS = 'dsw/settings/MODIFY_WIDGET_SETTINGS';
const TOGGLE_HIDDEN_ELEMENT = 'dsw/settings/TOGGLE_HIDDEN_ELEMENT';

export type $State = $WidgetSettings;

type $Action =
  | { type: 'dsw/settings/UNSET_WIDGET_SETTINGS' }
  | { type: 'dsw/settings/SET_WIDGET_SETTINGS', settings: $WidgetSettings }
  | { type: 'dsw/settings/MODIFY_WIDGET_SETTINGS', settings: $WidgetSettings }
  | { type: 'dsw/settings/TOGGLE_HIDDEN_ELEMENT', +fieldKey: string, +isActive: boolean };

const initialState: $State = {
  apiKey: ''
};

export default (state: $State, action: $Action) => {
  if (!state) state = initialState;
  switch (action.type) {
    case SET_WIDGET_SETTINGS:
      return action.settings;

    case UNSET_WIDGET_SETTINGS:
      return {
        ...state,
        configId: null,
        market: null,
        language: null
      };

    case MODIFY_WIDGET_SETTINGS:
      return { ...state, ...action.settings };

    case TOGGLE_HIDDEN_ELEMENT: {
      const { fieldKey, isActive } = action;
      if (!isActive && state.hiddenFields) {
        return {
          ...state,
          hiddenFields: [...state.hiddenFields, fieldKey]
        };
      } else if (!isActive && !state.hiddenFields) {
        return {
          ...state,
          hiddenFields: [fieldKey]
        };
      } else if (isActive && state.hiddenFields) {
        return {
          ...state,
          hiddenFields: state.hiddenFields.filter(element => fieldKey !== element)
        };
      } else return state;
    }

    default:
      return state;
  }
};

export const setWidgetSettings = (settings: $WidgetSettings) => {
  if (!settings.env) settings.env = Environments.ENV_LOCAL;
  return {
    type: SET_WIDGET_SETTINGS,
    settings
  };
};

export const unsetWidgetSettings = () => ({
  type: UNSET_WIDGET_SETTINGS
});

export const modifyWidgetSettings = (settings: $WidgetSettings) => ({
  type: MODIFY_WIDGET_SETTINGS,
  settings
});

export const toggleWidgetSettingsHiddenField = (fieldKey: string, isActive: boolean) => ({
  type: TOGGLE_HIDDEN_ELEMENT,
  fieldKey,
  isActive
});
